import { useEffect, useState } from "react"
import { useAuth } from "./AuthProvider"
import { useEsriModules } from "./useEsriModules"

/** Returns an instance of the portal */
export const usePortal = (): __esri.Portal | undefined => {
  const { status } = useAuth()
  const [portal, setPortal] = useState<__esri.Portal | undefined>()
  const [Portal] = useEsriModules(["esri/portal/Portal"])
  useEffect(() => {
    if (status === "signedIn" && Portal) {
      const portal = new Portal()
      portal.authMode = "immediate"
      portal.load().then(() => setPortal(portal))
    }
  }, [status, Portal])

  return portal
}
